export default __webpack_public_path__ + "static/media/noResultsCorrespondence.3f9492a6.svg";